import { render, staticRenderFns } from "./PaymentCards.vue?vue&type=template&id=5523d2ec"
import script from "./PaymentCards.vue?vue&type=script&lang=js"
export * from "./PaymentCards.vue?vue&type=script&lang=js"
import style0 from "./PaymentCards.vue?vue&type=style&index=0&id=5523d2ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports